export default __webpack_public_path__ + "f30964691f2622558ac3c44227be20d3.svg";